
export const getSalesInitialValues = client => {
  if (client) {
    return {
      project: null,
      unit: null,
      amount: undefined,
      receiptNumber: null,
      modeOfPayment: null,
      paymentProof: [],
      referenceNumber: null,
      depositDate: null,
      paymentType: null,
      bank: null,
      comment: "",
    }
  }
}
